import React from "react";

export const SyncForPayrollIcon: React.FC = () => {
  return (
    <svg
      data-testid="sync-for-payroll-icon"
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_1530_922)">
        <g clipPath="url(#clip0_1530_922)">
          <rect x="3" y="2" width="48" height="48.0001" rx="8" fill="#CCA4FF" />
          <rect
            x="35.1211"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 35.1211 2)"
            fill="#3E1C95"
          />
          <rect
            x="38.6719"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 38.6719 2)"
            fill="#3E1C95"
          />
          <rect
            x="31.5703"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 31.5703 2)"
            fill="#3E1C95"
          />
          <rect
            x="24.4727"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 24.4727 2)"
            fill="#3E1C95"
          />
          <rect
            x="20.9219"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 20.9219 2)"
            fill="#3E1C95"
          />
          <rect
            x="17.3711"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 17.3711 2)"
            fill="#3E1C95"
          />
          <rect
            x="51"
            y="34.127"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 34.127)"
            fill="#3E1C95"
          />
          <rect
            x="51"
            y="37.6758"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 37.6758)"
            fill="#3E1C95"
          />
          <rect
            x="51"
            y="30.5762"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 30.5762)"
            fill="#3E1C95"
          />
          <rect
            x="51"
            y="23.4766"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 23.4766)"
            fill="#3E1C95"
          />
          <rect
            x="51"
            y="19.9258"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 19.9258)"
            fill="#3E1C95"
          />
          <rect
            x="51"
            y="16.375"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 16.375)"
            fill="#3E1C95"
          />
          <g filter="url(#filter1_di_1530_922)">
            <rect
              x="7"
              y="6"
              width="40"
              height="40.0001"
              rx="6"
              fill="#1A0044"
            />
            <rect
              x="7.24859"
              y="6.24859"
              width="39.5028"
              height="39.5029"
              rx="5.75141"
              stroke="black"
              strokeOpacity="0.2"
              strokeWidth="0.49718"
            />
          </g>
          <path
            d="M28.9684 37.6673C30.5825 37.6673 35.631 37.6673 36.334 37.4543M20.934 14.334C18.9738 14.334 17.9937 14.334 17.245 14.7155C16.5865 15.051 16.051 15.5865 15.7155 16.245C15.334 16.9937 15.334 17.9738 15.334 19.934V32.0673C15.334 34.0275 15.334 35.0076 15.7155 35.7563C16.051 36.4149 16.5865 36.9503 17.245 37.2859C17.3772 37.3532 17.5166 37.4087 17.6673 37.4543M17.6673 37.4543C18.3704 37.6673 19.3199 37.6673 20.934 37.6673H23.2309M17.6673 37.4543C17.6677 36.5101 17.6734 36.0105 17.757 35.5902C18.1252 33.739 19.5723 32.2919 21.4236 31.9237C21.8744 31.834 22.4165 31.834 23.5007 31.834H30.5007C31.5849 31.834 32.127 31.834 32.5777 31.9237C34.429 32.2919 35.8761 33.739 36.2443 35.5902C36.3279 36.0105 36.3336 36.5101 36.334 37.4543M36.334 37.4543C36.4847 37.4087 36.6241 37.3532 36.7563 37.2859C37.4149 36.9503 37.9503 36.4149 38.2859 35.7563C38.6673 35.0076 38.6673 34.0275 38.6673 32.0673V19.934C38.6673 17.9738 38.6673 16.9937 38.2859 16.245C37.9503 15.5865 37.4149 15.051 36.7563 14.7155C36.0076 14.334 35.0275 14.334 33.0673 14.334H31.534M31.6673 23.834C31.6673 26.4113 29.578 28.5007 27.0007 28.5007C24.4233 28.5007 22.334 26.4113 22.334 23.834C22.334 21.2567 24.4233 19.1673 27.0007 19.1673C29.578 19.1673 31.6673 21.2567 31.6673 23.834Z"
            stroke="white"
            strokeWidth="1.7846"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.4727 14.3333H27.3227M27.3227 14.3333L24.9893 16.6667M27.3227 14.3333L24.9893 12"
            stroke="white"
            strokeWidth="1.7846"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M33.1836 37.6667L27.851 37.6667M27.851 37.6667L30.1843 35.3333M27.851 37.6667L30.1843 40"
            stroke="white"
            strokeWidth="1.7846"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <rect
          x="3.21818"
          y="2.21818"
          width="47.5636"
          height="47.5637"
          rx="7.78182"
          stroke="black"
          strokeOpacity="0.2"
          strokeWidth="0.436364"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_1530_922"
          x="0.745718"
          y="0.497145"
          width="52.5086"
          height="52.5086"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="0.751427"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_1530_922"
          />
          <feOffset dy="0.751427" />
          <feGaussianBlur stdDeviation="0.751427" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1530_922"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.751427" />
          <feGaussianBlur stdDeviation="1.12714" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_1530_922"
            result="effect2_dropShadow_1530_922"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_1530_922"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_di_1530_922"
          x="3"
          y="3"
          width="48"
          height="48"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1530_922"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1530_922"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.99436" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_1530_922"
          />
        </filter>
        <clipPath id="clip0_1530_922">
          <rect x="3" y="2" width="48" height="48.0001" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
